import { Routes } from '@angular/router';

export const shippingRoutes: Routes = [
  {
    path: 'order/:id',
    loadComponent: () => import('./shipping-order/shipping-order.component').then((m) => m.ShippingOrderComponent),
  },
];
